import { track } from '../track';
import { getExperimentSession, setExperimentSession } from './utils';

const EXPERIMENT_NAME = 'ecomm500';

type TrackCheckoutExperimentArgs = {
  flagValue?: string;
  label: string;
  leadUuid: string;
  quoteId?: string;
};

const _trackCheckoutExperiment = async ({
  label,
  leadUuid,
  quoteId = '',
  flagValue = 'empty',
}: TrackCheckoutExperimentArgs) => {
  try {
    await track('experiment', {
      category: EXPERIMENT_NAME,
      label,
      value: JSON.stringify({ leadUuid, quoteId, flagValue }),
      newrelicMetadata: {
        flagValue,
        leadUuid,
        quoteId,
        uniqueId: leadUuid,
      },
    });
  } catch (err) {
    console.error('[_trackCheckoutExperiment] Error tracking experiment', err);
  }
};

const _getLeadAndQuoteFromUrl = () => {
  const urlParams =
    typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;

  if (!urlParams) return { leadUuid: null, quoteId: null };

  return { leadUuid: urlParams.get('lead_id'), quoteId: urlParams.get('q') };
};

const _getCheckoutExperimentFlagValue = (leadUuid: string) => {
  try {
    const flagValue = getExperimentSession(EXPERIMENT_NAME, leadUuid);
    if (!flagValue) return null;

    return flagValue;
  } catch (err) {
    console.error('[_getCheckoutExperimentFlagValue] Error getting value', err);
    return null;
  }
};

export const sendQuotesLoadedEvent = async (quoteId: string, flagValue: string) => {
  const { leadUuid } = _getLeadAndQuoteFromUrl();
  if (!leadUuid) return;

  setExperimentSession(EXPERIMENT_NAME, leadUuid, flagValue);

  await _trackCheckoutExperiment({
    label: 'quotes-loaded',
    leadUuid,
    quoteId,
    flagValue,
  });
};

export const sendCheckoutPageViewEvent = async () => {
  const { leadUuid, quoteId } = _getLeadAndQuoteFromUrl();
  if (!leadUuid || !quoteId) return;

  const flagValue = _getCheckoutExperimentFlagValue(leadUuid);
  if (!flagValue) return;

  await _trackCheckoutExperiment({
    label: 'checkout-page-view',
    leadUuid,
    quoteId,
    flagValue,
  });
};

export const sendPurchaseEvent = async (type: 'started' | 'success' | 'error') => {
  const { leadUuid, quoteId } = _getLeadAndQuoteFromUrl();
  if (!leadUuid || !quoteId) return;

  const flagValue = _getCheckoutExperimentFlagValue(leadUuid);
  if (!flagValue) return;

  await _trackCheckoutExperiment({
    label: `checkout-${type}-nme`,
    leadUuid,
    quoteId,
    flagValue,
  });
};
